import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PageContainer } from '@/components';
import { UploadRegistryProvider } from '@/features/documents/context/UploadRegistryContext';

// Layout route for all documents pages. Persists across folder navigation so
// the upload registry survives route transitions between index and folder routes.
export const Route = createFileRoute('/_app/documents')({
  component: () => (
    <UploadRegistryProvider>
      <PageContainer>
        <Outlet />
      </PageContainer>
    </UploadRegistryProvider>
  ),
});
